<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('stageId')" class="col-sm-4 col-form-label">Stage</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('stageId')" v-model="stageId" :options="optionsStages"
                         text-field="dcat_name" value-field="dcat_id">
          </b-form-select>
        </div>
      </div>
      <table class="table table-bordered table-responsive table-hover table-sm" v-if="rounds && rounds.length">
        <thead>
        <tr>
          <th>Round</th>
          <th>Templates</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in rounds">
          <td>{{ row.name }}</td>
          <td>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateLowerThirds(row, 'lead')"
                    title="Lower Thirds Lead">LTL
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateLowerThirds(row, 'speed')"
                    title="Lower Thirds Speed">LTS
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateStartingList(row)"
                    title="Starting List">SL
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateLeadIntermediate(row)"
                    title="Lead Intermediate">LI
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateRankingListProvisional(row)"
                    title="Ranking List Provisional">RP
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateRankingListResults(row)"
                    title="Ranking List Results">RR
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateVictoryCeremonyAthlete(row)"
                    title="Victory Ceremony Athlete">VCA
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateVictoryCeremonyGroup(row)"
                    title="Victory Ceremony Group">VCG
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-12">
          <button type="button" class="btn btn-block btn-primary" @click="fetchLeagues">Fetch</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('leagueId')" class="col-sm-4 col-form-label">League</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('leagueId')" v-model="leagueId" :options="optionsLeagues" text-field="name"
                         value-field="id">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('eventId')" class="col-sm-4 col-form-label">Event</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('eventId')" v-model="eventId" :options="optionsEvents" text-field="event"
                         value-field="event_id">
          </b-form-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { uuid } from '@/lib'
  import { templateMixin } from '@/mixins'
  import { mapTemplateOptions } from '../../utils/index'
  import VerticalLifeApi from '../../api/VerticalLifeApi'
  import AppService from '../../api/AppService'
  import * as mutation from '../../store/mutation-types'

  export default {
    name: 'uiaa-vertical-life',
    mixins: [templateMixin],
    data () {
      return {
        errorMessage: null,
        leagues: [],
        events: [],
        stages: [],
        rounds: [],
        group: 0
      }
    },
    created () {
      this.verticalLifeApi = new VerticalLifeApi({
        baseUrl: 'https://uiaa.results.info',
        // TODO: This does not update the auth token in vertical-life-dataset.vue
        authToken: '63b0083436935fc8492e16de93cfa929485a5ce3'
      })
      this.appService = new AppService(this.$store, this.$keycloak)
    },
    mounted () {
      this.fetchLeagues().then(() => {
        if (this.leagueId) {
          this.fetchEvents(this.leagueId).then(() => {
            if (this.eventId) {
              this.fetchStages(this.eventId).then(() => {
                if (this.stageId) {
                  this.fetchRounds(this.eventId, this.stageId)
                }
              })
            }
          })
        }
      })
    },
    computed: {
      ...mapTemplateOptions(['leagueId', 'eventId', 'stageId', 'routeId']),
      optionsLeagues () {
        return [{name: '', id: null}].concat(this.leagues || [])
      },
      optionsEvents () {
        return [{event: '', event_id: null}].concat(this.events || [])
      },
      optionsStages () {
        return [{dcat_name: '', dcat_id: null}].concat(this.stages || [])
      }
    },
    watch: {
      leagueId: function (val) {
        console.debug('[uiaa] watched leagueId', val)
        this.fetchEvents(val)
      },
      eventId: function (val) {
        console.debug('[uiaa] watched eventId ' + val)
        this.fetchStages(val)
      },
      stageId: function (val) {
        console.debug('[uiaa] watched stageId ' + val)
        this.fetchRounds(this.eventId, val)
      }
    },
    methods: {
      openCreateLowerThirds (round, type) {
        const componentTypes = {
          'lead': 'uiaa-lower-third-lead',
          'speed': 'uiaa-lower-third-speed'
        }
        const stage = this.getStage()
        const url = this.api().getStartingListUrl(round)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.dcat_name + ' ' + round.name + ' Starting List',
          url
        }, 'vertical-life-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Lower Thirds ' + stage.dcat_name + ' ' + round.name,
          componentType: componentTypes[type],
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {},
          columnMap: {}
        })
      },
      openCreateStartingList (round) {
        const stage = this.getStage()
        const url = this.api().getStartingListUrl(round)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.dcat_name + ' ' + round.name + ' Starting List',
          url
        }, 'vertical-life-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Starting List ' + stage.dcat_name + ' ' + round.name,
          componentType: 'starting-list',
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {
            title: ('STARTING LIST ' + stage.dcat_name + ' ' + round.name).toUpperCase(),
            subtitle: (this.getEvent() || {}).destination
          },
          columnMap: {
            'bibNumber': 'BIB',
            'lastName': 'LAST NAME',
            'firstName': 'FIRST NAME',
            'country': 'COUNTRY'
          }
        })
      },
      openCreateLeadIntermediate (round) {
        const stage = this.getStage()
        const url = this.api().getStartingListUrl(round)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.dcat_name + ' ' + round.name + ' Intermediates',
          url,
          columns: ['TIME']
        }, 'vertical-life-dataset-window')
        window.setTimeout(function () {
          this.$store.commit(mutation.DATASET_UPDATE_META, {
            datasetId,
            fileName: this.api().getRankingListUrl(round),
            emit: true
          })
        }.bind(this), 1000)
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Intermediates ' + stage.dcat_name + ' ' + round.name,
          componentType: 'uiaa-lead-intermediate-standings',
          templateData: {datasetId},
          templateOptions: {},
          columnMap: {
            'bibNumber': 'BIB',
            'lastName': 'LAST NAME',
            'firstName': 'FIRST NAME',
            'country': 'COUNTRY',
            'score': 'SCORE',
            'endTime': 'ENDTIME'
          }
        })
      },
      openCreateRankingListProvisional (round) {
        this.openCreateRankingList(round, true)
      },
      openCreateRankingListResults (round) {
        this.openCreateRankingList(round, false)
      },
      openCreateRankingList (round, provisional) {
        const stage = this.getStage()
        const url = this.api().getRankingListUrl(round)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.dcat_name + ' ' + round.name + ' Ranking List',
          url
        }, 'vertical-life-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Ranking List ' + (provisional ? 'w/o' : 'w/') + ' Results ' + stage.dcat_name + ' ' + round.name,
          componentType: 'ranking-list',
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {
            title: ('PROVISIONAL RANKINGS ' + stage.dcat_name + ' ' + round.name).toUpperCase(),
            subtitle: (this.getEvent() || {}).destination
          },
          columnMap: {
            'bibNumber': 'BIB',
            'lastName': 'LAST NAME',
            'firstName': 'FIRST NAME',
            'country': 'COUNTRY',
            'rank': 'RANK',
            'score': 'SCORE',
            'qualified': 'QUALIFIED'
          },
          overlays: [
            provisional ? 'uiaa/ranking-list-without-results.vue' : 'uiaa/ranking-list-with-results.vue'
          ]
        })
      },
      openCreateVictoryCeremonyAthlete (round) {
        const stage = this.getStage()
        const url = this.api().getRankingListUrl(round)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.dcat_name + ' ' + round.name + ' Ranking List',
          url
        }, 'vertical-life-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Victory Ceremony Athlete ' + stage.dcat_name + ' ' + round.name,
          componentType: 'uiaa-victory-ceremony-athlete',
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {
            title: (stage.dcat_name).toUpperCase()
          }
        })
      },
      openCreateVictoryCeremonyGroup (round) {
        const stage = this.getStage()
        const url = this.api().getRankingListUrl(round)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.dcat_name + ' ' + round.name + ' Ranking List',
          url
        }, 'vertical-life-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Victory Ceremony Group ' + stage.dcat_name + ' ' + round.name,
          componentType: 'uiaa-victory-ceremony-group',
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {
            title: (stage.dcat_name).toUpperCase()
          }
        })
      },
      fetchLeagues () {
        this.errorMessage = null
        return this.api().fetchLeagues()
          .then(leagues => {
            console.log('[uiaa] fetched ' + leagues.length + ' leagues')
            this.leagues = leagues
          })
          .catch(err => {
            console.error('[uiaa] error fetching leagues', err)
            this.errorMessage = err.message
          })
      },
      fetchEvents (leagueId) {
        this.errorMessage = null
        return this.api().fetchEvents(leagueId)
          .then(events => {
            console.log('[uiaa] fetched ' + events.length + ' events')
            this.events = events
          })
          .catch(err => {
            console.error('[uiaa] error fetching events', err)
            this.errorMessage = err.message
          })
      },
      fetchStages (eventId) {
        this.errorMessage = null
        console.log('[uiaa] fetching stages for event ' + eventId)
        return this.api().fetchStages(eventId)
          .then(stages => {
            console.log('[uiaa] fetched ' + stages.length + ' stages')
            this.stages = stages
          })
          .catch(err => {
            console.error('[uiaa] error fetching stages', err)
            this.errorMessage = err.message
          })
      },
      fetchRounds (eventId, stageId) {
        this.errorMessage = null
        console.log(`[uiaa] fetching rounds for event ${eventId}, stage ${stageId}`)
        this.api().fetchRounds(eventId, stageId)
          .then(rounds => {
            console.log('[uiaa] fetched ' + rounds.length + ' rounds')
            this.rounds = rounds
          })
          .catch(err => {
            console.error('[uiaa] error fetching rounds', err)
            this.errorMessage = err.message
          })
      },
      getEvent () {
        return this.events.find(p => p.id === this.eventId)
      },
      getStage () {
        return this.stages.find(p => p.dcat_id === this.stageId)
      },
      api () {
        return this.verticalLifeApi
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/templates/uiaa-vertical-life.vue